import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { useFieldWrapper } from '@/components/shared/components/NewContextForms/FieldWrapperContext';
import {
  CustomTextField,
  CustomTextFieldProps,
} from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { ReadOnlyDataRow } from '@/components/shared/components/NewContextForms/shared/ReadOnlyDataRow';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export interface TextFormFieldProps<TFieldValues extends FieldValues> extends CustomTextFieldProps<TFieldValues> {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

export function TextFormField<T extends FieldValues>({ name, dummyField = false, ...props }: TextFormFieldProps<T>) {
  const formControl = useFormContext()?.control;
  const wrapField = useFieldWrapper();

  if (!formControl || dummyField) {
    if (props.fieldVariant === FieldVariant.form) {
      return <CustomTextField disabled={true} {...props} />;
    }
    return <ReadOnlyDataRow {...props} />;
  }

  return wrapField(
    name,
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomTextField
          field={field}
          value={field.value || ''}
          error={error}
          disabled={dummyField}
          fieldVariant={props.fieldVariant ?? FieldVariant.form}
          {...props}
        />
      )}
    />,
  );
}
